// import RepositoryFactory from "@/apis";
// const coach = RepositoryFactory.coach;
import coach from "../../apis/coach";

export default {
  getcoachtable({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.getcoachtable(payload);

        commit("SET_COACH_TABLE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getcoachannonce({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.getcoachannonce(payload);

        commit("SET_COACH_ANNOUNCE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editcoachannounce({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.editcoachannounce(payload);

        commit("EDIT_COACH_ANNOUNCE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getcoachform({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.getcoachform(payload);

        commit("GET_COACH_FORM", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  Sessiondate({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.Sessiondate(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetSession({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.GetSession(payload);

        commit("GET_COACH_SESSION", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  DeleteSession({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.DeleteSession(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  EditSession({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.EditSession(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  // ############################## BROCHURE COACH ###########################
  // ############################## BROCHURE COACH ###########################

  CreateBrochure({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.CreateBrochure(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetBrochure({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.GetBrochure(payload);
        commit("BROACH_GET_ALL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  DeleteBrochure({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.DeleteBrochure(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  EditBrochure({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await coach.EditBrochure(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
